import { Box, CircularProgress, Grid, Typography } from "@mui/material";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import React, { useCallback, useEffect, useState } from "react";
import { getDeliveryTeamStats } from "../../../../api/DeliveryAnalyticsService";

export const DeliveryTeamStats = ({ startDate, endDate }) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    loadData();
  }, [loadData, startDate, endDate]);

  const loadData = useCallback(async () => {
    if (!startDate || !endDate) return;

    setLoading(true);
    setError(null);

    try {
      // Create params object for API calls
      const params = {
        start_date: startDate,
        end_date: endDate,
      };

      // Call the stats API
      const response = await getDeliveryTeamStats(params);

      // Set stats data directly from API response
      setData(response.data);
    } catch (err) {
      console.error("Error loading order stats data:", err);
      setError("Não foi possível carregar os dados de pedidos");
    } finally {
      setLoading(false);
    }
  }, [startDate, endDate]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: 300,
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
        <PeopleAltIcon sx={{ mr: 1, color: "info.main" }} />
        <Typography variant="h6">Equipe de Entrega</Typography>
      </Box>

      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Total de Entregadores
          </Typography>
          <Typography variant="h5">
            {data.totalDrivers.toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="body2" color="text.secondary">
            Entregas por Entregador
          </Typography>
          <Typography variant="h5">
            {data.avgOrdersPerDriver.toFixed(1)}
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};
